import React from 'react'

import { IconSVGProps } from '@sidecar-components/atoms/Icon/Icon.types'

export const DiscountCodes = ({
  className,
  pathClass,
  size = 6,
  ...rest
}: IconSVGProps) => (
  <svg
    aria-label="discount codes icon"
    className={`shrink-0 h-${size} w-${size} ${className}`}
    viewBox="0 0 64 64"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13 12L13 52C13 55.866 16.134 59 20 59H44C47.866 59 51 55.866 51 52V12C51 8.13401 47.866 5 44 5H20C16.134 5 13 8.13401 13 12ZM10 52C10 57.5228 14.4772 62 20 62H44C49.5228 62 54 57.5228 54 52V12C54 6.47715 49.5228 2 44 2H20C14.4772 2 10 6.47715 10 12L10 52Z"
      className={`color-iconBrand-default ${pathClass}`}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19 42.5C19 41.6716 19.6716 41 20.5 41L33.5 41C34.3284 41 35 41.6716 35 42.5C35 43.3284 34.3284 44 33.5 44H20.5C19.6716 44 19 43.3284 19 42.5Z"
      className={`color-iconBrand-default ${pathClass}`}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19 49.5C19 48.6716 19.6716 48 20.5 48L33.5 48C34.3284 48 35 48.6716 35 49.5C35 50.3284 34.3284 51 33.5 51H20.5C19.6716 51 19 50.3284 19 49.5Z"
      className={`color-iconBrand-default ${pathClass}`}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M39 42.5C39 41.6716 39.6716 41 40.5 41H43.5C44.3284 41 45 41.6716 45 42.5C45 43.3284 44.3284 44 43.5 44H40.5C39.6716 44 39 43.3284 39 42.5Z"
      className={`color-iconBrand-default ${pathClass}`}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M39 49.5C39 48.6716 39.6716 48 40.5 48H43.5C44.3284 48 45 48.6716 45 49.5C45 50.3284 44.3284 51 43.5 51H40.5C39.6716 51 39 50.3284 39 49.5Z"
      className={`color-iconBrand-default ${pathClass}`}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M32 35C25.3846 35 20 29.6171 20 23C20 16.3846 25.3846 11 32 11C38.6154 11 44 16.3846 44 23C44 29.6171 38.6154 35 32 35"
      className={`color-iconBrand-default ${pathClass}`}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M32 14C27.0392 14 23 18.0392 23 23C23 27.9644 27.0392 32 32 32C36.9644 32 41 27.9644 41 23C41 18.0392 36.9644 14 32 14"
      className={`color-iconPrimary-disabled ${pathClass}`}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M28 18V25.3077H29.8901V22.5275H30.2747L32.3378 25.2893L30.3077 28.0002H32.4062L33.3885 26.6959L34.3626 28H36.4615L34.4506 25.2857L36.4616 22.6156H34.34L33.4012 23.8693L32.2198 22.2747C33.033 21.8901 33.4945 21.0879 33.4945 20.1868C33.4945 18.9121 32.5824 18 31.044 18H28ZM30.8242 20.9011H29.8901V19.4725H30.8242C31.3407 19.4725 31.6923 19.6484 31.6923 20.1868C31.6923 20.7253 31.3407 20.9011 30.8242 20.9011Z"
      className={`color-iconBrand-default ${pathClass}`}
    />
  </svg>
)
